module.exports = {"id":"198200","name":"Benjamin Stambouli","rating":"78","photo":"./data/images/photos/0/198200.png","club":{"name":"FC Schalke 04","logo":"./data/images/clubs/FCSchalke04.png"},"positions":["DC","MDC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BenjaminStambouli0.json
// module id = 577
// module chunks = 0